import dynamic from 'next/dynamic';
import Link from 'next/link';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import Container from './Container';
const Slider = dynamic(() => import('react-slick'));
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../writetous/writesuccessspotlights.css';
import CloudinaryImage from './CloudinaryImage';
export default function OurPortfolios({ OurPortfolios }) {
  const settings = {
    infinite: true,
    // initialSlide: 0.8,
    slidesToScroll: 1,
    slidesToShow: 3,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
        },
      },
    ],
  };
  return (
    <Container>
      {OurPortfolios?.titleEditor && (
        <div className="text-[#fff] lg:mb-[34px] mb-[30px] md:w-[90%] w-full">
          <ReactMarkdown
            rehypePlugins={[rehypeRaw]}
            className={`font-[800] xl:text-[55px] md:text-[32px] text-[26px] leading-tight mb-3`}
            source={OurPortfolios?.titleEditor}
          >
            {OurPortfolios?.titleEditor}
          </ReactMarkdown>
          <p className="lg:text-[20px] text-[16px] font-[400]">
            {OurPortfolios?.description}
          </p>
        </div>
      )}
      <Slider {...settings} className="spotlight-img">
        {OurPortfolios?.SolutionDesc?.map(data => (
          <div className="group text-[#fff]" key={data?.id}>
            <div className="relative lg:h-[500px] h-[400px] p-4 overflow-hidden rounded-[20px] after:transition after:duration-500 after:ease-out after:hover:delay-200 after:hover:duration-300 md:after:bg-[linear-gradient(180deg,_rgba(0,12,32,0.5)_-1.82%,_rgba(8,8,8,0.85)_100%)] md:after:hover:bg-[linear-gradient(180deg,_#1200B6_-1.82%,_rgba(8,8,8,0.95)_100%)]  after:bg-[linear-gradient(180deg,_#1200B6_-1.82%,_rgba(8,8,8,0.95)_100%)] after:absolute after:top-0 after:bottom-0 after:left-0 after:right-0">
              {data?.bgImage?.data?.attributes?.url && (
                <CloudinaryImage
                  backendImgUrl={data?.bgImage?.data?.attributes?.url}
                  className={`absolute top-0 bottom-0 left-0 right-0 w-full z-[0] h-full object-cover`}
                  alt={data?.bgImage?.data?.attributes?.alternativeText}
                  type="smallimg"
                />
              )}
              <h6 className="relative z-[1] line-clamp-2 xl:text-[34px] lg:text-[28px] text-[24px] font-[600] leading-tight tracking-[-1px] mb-[15px]">
                {data?.title}
              </h6>
              <p className="md:absolute relative md:left-[20px] md:top-1/5 z-[1] md:line-clamp-3 md:max-w-[90%] md:opacity-0 opacity-1 md:transition-opacity md:duration-300 md:ease-out md:group-hover:opacity-100 md:group-hover:delay-200 md:group-hover:duration-300 lg:text-[18px] text-[16px] font-[400] leading-tight mb-[15px]">
                {data?.description}
              </p>
              <Link
                href={`${data?.btn_link}`}
                className="lg:text-[22px] text-[16px] font-[400] leading-tight inline-block underline underline-offset-1 absolute z-[1] bottom-[15px] right-[15px]"
              >
                {`${data?.btn_text}`}
              </Link>
            </div>
          </div>
        ))}
      </Slider>
    </Container>
  );
}
